module.exports = __webpack_public_path__ + "media/images/ohap_manage roster_on-e17e903b1aa695016fbde14872aaa141.png";